import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { InventoryProvider } from '@/contexts/InventoryContext'
import { ProcurementProvider } from '@/contexts/ProcurementContext'
import { OrdersProvider } from '@/contexts/OrdersContext'
import { SalesProvider } from '@/contexts/SalesContext'
import { AccountingProvider } from '@/contexts/AccountingContext'
import { AdminProvider } from '@/contexts/AdminContext'
import { router } from './inventoryRoutes'

function App() {
  return (
    <InventoryProvider>
      <ProcurementProvider>
        <OrdersProvider>
          <SalesProvider>
            <AccountingProvider>
              <AdminProvider>
                <RouterProvider router={router} />
                <Toaster position="top-right" richColors />
              </AdminProvider>
            </AccountingProvider>
          </SalesProvider>
        </OrdersProvider>
      </ProcurementProvider>
    </InventoryProvider>
  )
}

export default App
